export const BUILD_ID = 'c413f374-36b6-41ef-8df7-9e258c648aca';
export const ENV = 'dev';
